import { gql } from '@/shared/graphql/generated/explorer';

export const getDelegationActivityQuery = gql(/* GraphQL */ `
  query GetDelegationActivity($delegationIdSs58: String, $first: Int, $offset: Int) {
    allDelegationActivities(
      filter: { accountByDelegatorAccountId: { idSs58: { equalTo: $delegationIdSs58 } } }
      offset: $offset
      first: $first
      orderBy: EVENT_ID_DESC
    ) {
      edges {
        node {
          id
          type
          amount
          valueUsd
          txHash
          event: eventByEventId {
            indexInBlock
            blockId
            block: blockByBlockId {
              timestamp
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`);

export const checkForActivityQuery = gql(/* GraphQL */ `
  query CheckForActivity($delegationIdSs58: String) {
    activity: allDelegationActivities(
      filter: { accountByDelegatorAccountId: { idSs58: { equalTo: $delegationIdSs58 } } }
      first: 1
    ) {
      totalCount
    }
  }
`);

export const getDelegationHistoryQuery = gql(/* GraphQL */ `
  query GetDelegationHistory($delegationIdSs58: String, $first: Int, $offset: Int) {
    allOperatorEpochDelegations(
      filter: { accountByDelegatorAccountId: { idSs58: { equalTo: $delegationIdSs58 } } }
      offset: $offset
      first: $first
      orderBy: ID_DESC
    ) {
      edges {
        node {
          id
          amount
          valueUsd
          rewards
          rewardsValueUsd
          delegator: accountByDelegatorAccountId {
            idSs58
            alias
          }
          operatorEpoch: operatorEpochByOperatorEpochId {
            epoch: epochByEpochId {
              id
              startBlock: blockByStartBlockId {
                id
                timestamp
              }
              endBlock: blockByEndBlockId {
                id
                timestamp
              }
            }
            operator: operatorByOperatorId {
              account: accountByAccountId {
                idSs58
                alias
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`);
